import { render } from "./Dict.vue?vue&type=template&id=30546678&scoped=true"
import script from "./Dict.vue?vue&type=script&lang=js"
export * from "./Dict.vue?vue&type=script&lang=js"

import "./Dict.vue?vue&type=style&index=0&id=30546678&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30546678"]])

export default __exports__